import * as React from 'react'
import { useMediaQuery } from 'react-responsive'
import theme from '@/components/themes/mainTheme'
import AppBar from '@mui/material/AppBar'
import Grid from '@mui/material/Grid2'
import Link from '@mui/material/Link'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import CssBaseline from '@mui/material/CssBaseline'
import LinkedInButton from '@/components/buttons/LinkedInButton'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import FacebookIcon from '@mui/icons-material/Facebook'
import InstagramIcon from '@mui/icons-material/Instagram'
import { Outlet } from 'react-router-dom'

const Baselayout: React.FC = () => {
  const isMobile = useMediaQuery({
    query: `(max-width: ${theme.breakpoints.values.md}px)`
  })

  return (
    <>
      <CssBaseline />
      <AppBar position='static' sx={{ color: '#000000' }}>
        <Grid
          container
          direction='row'
          justifyContent='space-between'
          alignItems='center'
          textAlign='center'
        >
          <Grid
            size={12}
            display='flex'
            justifyContent='center'
            alignItems='center'
            textAlign='center'
          >
            <img
              src={'/images/teatersmedjan-icon-round.png'}
              height={isMobile ? '25px' : '90px'}
            />
            <Typography
              variant={isMobile ? 'h5' : 'h3'}
              sx={{
                fontWeight: 700,
                color: 'inherit',
                textDecoration: 'none',
                textAlign: 'center',
                margin: 0,
              }}
            >
              TEATERSMEDJAN PLAY
              <PlayArrowIcon
                fontSize={isMobile ? 'medium' : 'large'}
                sx={{
                  verticalAlign: 'middle',
                  fontSize: isMobile ? '1.5em' : '2em'
                }}
              />
            </Typography>
          </Grid>
        </Grid>
      </AppBar>
      <Outlet context={{ isDrawerOpen: false }} />
      <AppBar
        position='static'
        color='primary'
        sx={{
          top: 'auto',
          bottom: 0,
          padding: '15px',
          color: '#FFFFFF',
          backgroundColor: '#353839',
        }}>
        <Grid
          container
          direction='row'
          justifyContent='center'
          spacing={5}
        >
          <Grid
            container
            direction='row'
            justifyContent='space-between'
            fontSize={'0.75em'}
            size={10}
          >
            <Grid size={{ xs: 11, md: 4 }}>
              <h3>Teatersmedjan i Blekinge</h3>
              <p>Lokstallarna
                Prinsgatan 43<br />
                374 33 Karlshamn<br />
                Telefon: 073-819 87 21 (Verksamhetsproducent)<br />
                E-post: post@teatersmedjan.se<br />
                Org.nr: 836200-9170<br />
                Bankgiro: 375-0866<br />
              </p>
            </Grid>
            <Grid size={{ xs: 11, md: 4 }}>
              <h3>Om Teatersmedjan</h3>
              <p>
                Teatersmedjan är en amatörteaterförening verksam i Blekinge.
                Föreningen bildades 1990 och har nu cirka 400 medlemmar.
              </p>
            </Grid>
            <Grid size={{ xs: 11, md: 4 }}>
              <h3>Snabblänkar</h3>
              <ul style={{ padding: 0 }}>
                <li><Link href='https://www.teatersmedjan.se/ledarestyrelse/'>Kontakt - Ledare & Styrelse</Link></li>
                <li><Link href='https://www.teatersmedjan.se/aktuella-forestallningar/'>Aktuella evenemang</Link></li>
                <li><Link href='https://www.teatersmedjan.se/foreningsinformation/'>Kontakt - Kansli</Link></li>
              </ul>
            </Grid>
          </Grid>
        </Grid>
      </AppBar>
      <AppBar
        position='static'
        color='primary'
        sx={{
          top: 'auto',
          bottom: 0,
          padding: '15px',
          color: '#FFFFFF',
          backgroundColor: '#333333',
        }}>
        <Grid container direction='row' justifyContent='space-between'>
          <Grid>
            <LinkedInButton />
          </Grid>
          <Grid>
            <IconButton
              sx={{ color: '#FFFFFF' }}
              onClick={() => window.open('https://www.instagram.com/teatersmedjan/')}
            >
              <InstagramIcon />
            </IconButton>
            <IconButton
              sx={{ color: '#FFFFFF' }}
              onClick={() => window.open('https://www.facebook.com/teatersmedjan/')}
            >
              <FacebookIcon />
            </IconButton>
          </Grid>
        </Grid>
      </AppBar>
    </>
  )
}
export default Baselayout